import { render, staticRenderFns } from "./FeaturesSection.vue?vue&type=template&id=06cb5214&scoped=true"
import script from "./FeaturesSection.vue?vue&type=script&lang=js"
export * from "./FeaturesSection.vue?vue&type=script&lang=js"
import style0 from "./FeaturesSection.vue?vue&type=style&index=0&id=06cb5214&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06cb5214",
  null
  
)

export default component.exports